export default __webpack_public_path__ + "static/media/image.1f9e9096.png";